import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    '--pay-color00': '#333333',
    '--pay-color01': '#333333',
    '--pay-color02': '#333333',
    '--pay-color03': '#ff4265',
    '--pay-color04': '#666666',
    '--pay-color05': '#b2b2b2',
    '--pay-color06': '#333333',
    '--pay-color07': '#b2b2b2',
    '--pay-color08': '#666666',
    '--pay-color09': '#b2b2b2',
    '--pay-color10': '#ffffff',
    '--pay-color11': '#333333',
    '--pay-color12': '#f95151',
    '--pay-color13': '#333333',
    '--pay-color14': '#ffffff',
    '--pay-color15': '#C36F00',
    '--pay-color16': '#b2b2b2',
    '--pay-color17': '#FF4265',
    '--pay-color18': '#ffffff',
    '--pay-color19': '#6849A6',
    '--pay-color20': '#6849A6',
    '--pay-color21': '#ffffff',
    '--pay-bg01': '#f9f9fb',
    '--pay-bg02': '#fefefe',
    '--pay-bg03': '#ffffff',
    '--pay-bg04': '#f4f5f7',
    '--pay-bg05': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg06': '#a338fc',
    '--pay-bg07': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg08': '#faedff',
    '--pay-bg09': '#ff4265',
    '--pay-bg10': 'rgba(255, 187, 40, 0.1)',
    '--pay-radius01': '100px',
    '--pay-icon01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check.webp')})`,
    '--pay-icon03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon.webp')})`,
    '--pay-icon05': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon-ar.webp')})`,
  },
  echo: {
    '--pay-color00': '#222222',
    '--pay-color01': '#222222',
    '--pay-color02': '#222222',
    '--pay-color03': '#f95151',
    '--pay-color04': '#222222',
    '--pay-color05': '#999999',
    '--pay-color06': '#222222',
    '--pay-color07': '#999999',
    '--pay-color08': '#222222',
    '--pay-color09': '#aeaeb2',
    '--pay-color10': '#ffffff',
    '--pay-color11': '#222222',
    '--pay-color12': '#f95151',
    '--pay-color13': '#222222',
    '--pay-color14': '#ffffff',
    '--pay-color15': '#C36F00',
    '--pay-color16': '#999999',
    '--pay-color17': '#FF4265',
    '--pay-color18': '#ffffff',
    '--pay-color19': '#FF7F2D',
    '--pay-color20': '#FF7F2D',
    '--pay-color21': '#ffffff',
    '--pay-bg01': '#f4f5f7',
    '--pay-bg02': '#fefefe',
    '--pay-bg03': '#ffffff',
    '--pay-bg04': '#f4f5f7',
    '--pay-bg05': 'rgba(255, 255, 255, 0.8)',
    '--pay-bg06': '#ff7f2d',
    '--pay-bg07': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg08': '#FFF7EA',
    '--pay-bg09': '#f95151',
    '--pay-bg10': 'rgba(255, 187, 40, 0.1)',
    '--pay-radius01': '100px',
    '--pay-icon01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check.webp')})`,
    '--pay-icon03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-icon.webp')})`,
    '--pay-icon05': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-icon-ar.webp')})`,
  },
  joychat: {
    '--pay-color00': '#222222',
    '--pay-color01': '#222222',
    '--pay-color02': '#222222',
    '--pay-color03': '#f95151',
    '--pay-color04': '#222222',
    '--pay-color05': '#999999',
    '--pay-color06': '#222222',
    '--pay-color07': '#999999',
    '--pay-color08': '#666666',
    '--pay-color09': '#aeaeb2',
    '--pay-color10': '#ffffff',
    '--pay-color11': '#222222',
    '--pay-color12': '#f95151',
    '--pay-color13': '#222222',
    '--pay-color14': '#ffffff',
    '--pay-color15': '#C36F00',
    '--pay-color16': '#999999',
    '--pay-color17': '#FF4265',
    '--pay-color18': '#ffffff',
    '--pay-color19': '#063D28',
    '--pay-color20': '#063D28',
    '--pay-color21': '#ffffff',
    '--pay-bg01': '#f9f9fb',
    '--pay-bg02': '#fefefe',
    '--pay-bg03': '#ffffff',
    '--pay-bg04': '#f4f5f7',
    '--pay-bg05': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg06': '#22c185',
    '--pay-bg07': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg08': '#D7FFEE',
    '--pay-bg09': '#f95151',
    '--pay-bg10': 'rgba(255, 187, 40, 0.1)',
    '--pay-radius01': '100px',
    '--pay-icon01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check.webp')})`,
    '--pay-icon03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-icon.webp')})`,
    '--pay-icon05': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-icon-ar.webp')})`,
  },
  joyu: {
    '--pay-color00': '#0C0E11',
    '--pay-color01': '#0C0E11',
    '--pay-color02': '#353A3F',
    '--pay-color03': '#FF5526',
    '--pay-color04': '#353A3F',
    '--pay-color05': '#8E9092',
    '--pay-color06': '#0C0E11',
    '--pay-color07': '#8E9092',
    '--pay-color08': '#353A3F',
    '--pay-color09': '#8E9092',
    '--pay-color10': '#5A0B1B',
    '--pay-color11': '#0C0E11',
    '--pay-color12': '#FF5526',
    '--pay-color13': '#353A3F',
    '--pay-color14': '#5A0B1B',
    '--pay-color15': '#C36F00',
    '--pay-color16': '#8E9092',
    '--pay-color17': '#FF4265',
    '--pay-color18': '#5A0B1B',
    '--pay-color19': '#5A0B1B',
    '--pay-color20': '#5A0B1B',
    '--pay-color21': '#ffffff',
    '--pay-bg01': '#F4F5F7',
    '--pay-bg02': '#ffffff',
    '--pay-bg03': '#ffffff',
    '--pay-bg04': '#F4F5F7',
    '--pay-bg05': 'transparent',
    '--pay-bg06': '#FF6A55',
    '--pay-bg07': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg08': '#FFECDD',
    '--pay-bg09': '#FF5526',
    '--pay-bg10': 'rgba(255, 187, 40, 0.1)',
    '--pay-radius01': '4px',
    '--pay-icon01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check.webp')})`,
    '--pay-icon03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-icon.webp')})`,
    '--pay-icon05': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-icon-ar.webp')})`,
  },
  kiko: {
    '--pay-color00': '#333333',
    '--pay-color01': '#333333',
    '--pay-color02': '#333333',
    '--pay-color03': '#ff4265',
    '--pay-color04': '#666666',
    '--pay-color05': '#b2b2b2',
    '--pay-color06': '#333333',
    '--pay-color07': '#b2b2b2',
    '--pay-color08': '#666666',
    '--pay-color09': '#b2b2b2',
    '--pay-color10': '#000000',
    '--pay-color11': '#333333',
    '--pay-color12': '#f95151',
    '--pay-color13': '#333333',
    '--pay-color14': '#000000',
    '--pay-color15': '#C36F00',
    '--pay-color16': '#b2b2b2',
    '--pay-color17': '#FF4265',
    '--pay-color18': '#000000',
    '--pay-color19': '#937A15',
    '--pay-color20': '#937A15',
    '--pay-color21': '#ffffff',
    '--pay-bg01': '#f9f9fb',
    '--pay-bg02': '#fefefe',
    '--pay-bg03': '#ffffff',
    '--pay-bg04': '#f4f5f7',
    '--pay-bg05': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg06': '#ffe242',
    '--pay-bg07': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg08': '#FFFCE6',
    '--pay-bg09': '#ff4265',
    '--pay-bg10': 'rgba(255, 187, 40, 0.1)',
    '--pay-radius01': '100px',
    '--pay-icon01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check.webp')})`,
    '--pay-icon03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-icon.webp')})`,
    '--pay-icon05': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-icon-ar.webp')})`,
  },
  vava: {
    '--pay-color00': '#333333',
    '--pay-color01': '#333333',
    '--pay-color02': '#333333',
    '--pay-color03': '#ff4265',
    '--pay-color04': '#666666',
    '--pay-color05': '#b2b2b2',
    '--pay-color06': '#333333',
    '--pay-color07': '#b2b2b2',
    '--pay-color08': '#666666',
    '--pay-color09': '#b2b2b2',
    '--pay-color10': '#ffffff',
    '--pay-color11': '#333333',
    '--pay-color12': '#f95151',
    '--pay-color13': '#333333',
    '--pay-color14': '#ffffff',
    '--pay-color15': '#C36F00',
    '--pay-color16': '#b2b2b2',
    '--pay-color17': '#FF4265',
    '--pay-color18': '#ffffff',
    '--pay-color19': '#6849A6',
    '--pay-color20': '#6849A6',
    '--pay-color21': '#ffffff',
    '--pay-bg01': '#f9f9fb',
    '--pay-bg02': '#fefefe',
    '--pay-bg03': '#ffffff',
    '--pay-bg04': '#f4f5f7',
    '--pay-bg05': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg06': '#a338fc',
    '--pay-bg07': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg08': '#faedff',
    '--pay-bg09': '#ff4265',
    '--pay-bg10': 'rgba(255, 187, 40, 0.1)',
    '--pay-radius01': '100px',
    '--pay-icon01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check.webp')})`,
    '--pay-icon03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon.webp')})`,
    '--pay-icon05': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon-ar.webp')})`,
  },
  vibeo: {
    '--pay-color00': '#333333',
    '--pay-color01': '#333333',
    '--pay-color02': '#333333',
    '--pay-color03': '#ff4265',
    '--pay-color04': '#666666',
    '--pay-color05': '#b2b2b2',
    '--pay-color06': '#333333',
    '--pay-color07': '#b2b2b2',
    '--pay-color08': '#666666',
    '--pay-color09': '#b2b2b2',
    '--pay-color10': '#733406',
    '--pay-color11': '#333333',
    '--pay-color12': '#f95151',
    '--pay-color13': '#333333',
    '--pay-color14': '#733406',
    '--pay-color15': '#C36F00',
    '--pay-color16': '#b2b2b2',
    '--pay-color17': '#FF4265',
    '--pay-color18': '#733406',
    '--pay-color19': '#733406',
    '--pay-color20': '#733406',
    '--pay-color21': '#ffffff',
    '--pay-bg01': '#f9f9fb',
    '--pay-bg02': '#fefefe',
    '--pay-bg03': '#ffffff',
    '--pay-bg04': '#f4f5f7',
    '--pay-bg05': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg06': '#ffa433',
    '--pay-bg07': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg08': '#FFF4D6',
    '--pay-bg09': '#ff4265',
    '--pay-bg10': 'rgba(255, 187, 40, 0.1)',
    '--pay-radius01': '100px',
    '--pay-icon01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check.webp')})`,
    '--pay-icon03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-icon.webp')})`,
    '--pay-icon05': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-icon-ar.webp')})`,
  },
  whonow: {
    '--pay-color00': '#0C0E11',
    '--pay-color01': '#222222',
    '--pay-color02': '#222222',
    '--pay-color03': '#F95151',
    '--pay-color04': '#666666',
    '--pay-color05': '#999999',
    '--pay-color06': '#222222',
    '--pay-color07': '#b2b2b2',
    '--pay-color08': '#222222',
    '--pay-color09': '#8E9092',
    '--pay-color10': '#0C0E11',
    '--pay-color11': '#222222',
    '--pay-color12': '#F95151',
    '--pay-color13': '#222222',
    '--pay-color14': '#102006',
    '--pay-color15': '#C36F00',
    '--pay-color16': '#999999',
    '--pay-color17': '#FF4265',
    '--pay-color18': '#0C0E11',
    '--pay-color19': '#102006',
    '--pay-color20': '#102006',
    '--pay-color21': '#ffffff',
    '--pay-bg01': '#F4F5F7',
    '--pay-bg02': '#ffffff',
    '--pay-bg03': '#ffffff',
    '--pay-bg04': '#F4F5F7',
    '--pay-bg05': '#ffffff',
    '--pay-bg06': '#B9E86F',
    '--pay-bg07': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg08': '#EAF5C8',
    '--pay-bg09': '#F95151',
    '--pay-bg10': 'rgba(255, 187, 40, 0.1)',
    '--pay-radius01': '100px',
    '--pay-icon01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check.webp')})`,
    '--pay-icon03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-icon.webp')})`,
    '--pay-icon05': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-icon-ar.webp')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      const base = getBaseFeature()
      const pkg = this.packageName && styObj[this.packageName] ? styObj[this.packageName] : styObj.default
      if (typeof window !== 'undefined' && window.lang === 'ar') {
        return { ...pkg, ...base }
      }
      return { ...base, ...pkg }
    },
  },
}
